import React, {forwardRef} from "react";
import PropTypes from "prop-types";
import ReactQuill, {Quill} from "react-quill";
import QuillResizeImage from 'quill-resize-image';

import 'react-quill/dist/quill.snow.css';
import "./quillTextEditor.css"

Quill.register("modules/resize", QuillResizeImage);


let Size = Quill.import('attributors/style/size');

Size.whitelist = [false, '8px', '9px', '10px', '11px', '12px', '13px', '14px', '16px', '18px', '20px', '22px', '24px', '30px', '36px', '48px', '60px', '72px'];
Quill.register(Size, true);

const modules = {
    toolbar: [
        [{'header': [1, 2, 3, 4, 5, 6, false]}],
        [{'size': [...Size.whitelist]}],
        ['bold', 'italic', 'underline', 'strike', 'blockquote'],
        [{'color': []}, {'background': []}],
        [{'list': 'ordered'}, {'list': 'bullet'}, {'indent': '-1'}, {'indent': '+1'}],
        ['link'],
        [{align: ''}, {align: 'center'}, {align: 'right'}, {align: 'justify'}],
        ['image'],
        ['clean'],
    ],
    resize: {
        locale: {},
    },
    clipboard: {
        matchVisual: false
    }
};

const formats = [
    'header', 'size',
    'bold', 'italic', 'underline', 'strike', 'blockquote',
    'color', 'background',
    'list', 'bullet', 'indent',
    'link', 'image', 'align'
];
const QuillTextEditor = forwardRef(({onChange, value, ...other}, ref) => {
    return (
        <ReactQuill
            value={value}
            ref={ref}
            modules={modules}
            formats={formats}
            onChange={onChange}
            {...other}
        />
    )
})
export default QuillTextEditor;

QuillTextEditor.propTypes = {
    value: PropTypes.string,
    onChange: PropTypes.func,
    ref: PropTypes.any,
    preserveWhitespace: PropTypes.bool,
}